import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { PurchaseRequestsView } from '@/components/features/parts/components/purchase-requests/PurchaseRequestsView';

export const Route = createFileRoute('/_authenticated/purchase-requests')({
  component: PurchaseRequestsPage,
});

function PurchaseRequestsPage() {
  const { t } = useTranslation(['parts', 'common']);

  return (
    <div className="flex flex-col gap-4 sm:gap-6">
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1">
          <h1 className="text-xl sm:text-2xl font-bold tracking-tight">
            {t('purchaseRequests.title')}
          </h1>
          <p className="text-xs sm:text-sm text-muted-foreground">
            {t('purchaseRequests.description')}
          </p>
        </div>
      </div>
      <PurchaseRequestsView />
    </div>
  );
}
